<div class="pill-container">
  <button
    *ngFor="let pill of pills"
    class="pill"
    type="button"
    (click)="pillSelected(pill)"
    [ngClass]="{
          active: pill?.selected,
          error: hasError,
          errorBorder: hasError,
         }"
    [disabled]="disabled">
    <ng-container>{{ pill?.title }}</ng-container>
  </button>
</div>
